import { Box, Grid } from "@material-ui/core";
import { useEffect, useRef } from "react";
import ScrollAnimation from "react-animate-on-scroll";
import { useTranslation } from "react-i18next";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useHistory } from "react-router";
import GeneralButton from "../../Utils/GeneralButton/GeneralButton";
import { mainContentStyle } from "./mainContentStyle";


const FacilitySection = () => {

    const classes = mainContentStyle();
    const textRef: any = useRef(null);
    const animationRef: any = useRef(null);
    const { t } = useTranslation("mainContent");
    const history = useHistory();
    useEffect(() => {
        const handleScroll = () => {
            const maxScrollTop = document.documentElement.scrollHeight - window.innerHeight;
            if (window.scrollY - 300 <= maxScrollTop - animationRef.current?.getBoundingClientRect().height && window.scrollY + 500 >= textRef.current.getBoundingClientRect().top + window.scrollY) {
                textRef.current.classList.add('animate-once');
            } else {
                textRef.current.classList.remove('animate-once');

            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);


    return (
        <section ref={animationRef} style={{ minHeight: "max-content" }}>
            <Box className="row justify-content-center">
                <Grid item lg={12}>
                    <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                        <Box
                            sx={{
                                marginTop: {
                                    xs: "30px",
                                    sm: "30px",
                                    md: "140px",
                                    lg: "140px",
                                },
                                marginRight: "auto",
                                marginLeft: "auto",
                            }}
                        >
                            <div className={classes.facilitySecCntnr}>
                                <Box
                                    sx={{
                                        maxWidth: "100%",
                                    }}
                                >
                                    <div className="row justify-content-center w-100 ml-0 mr-0 ">
                                        <div
                                            ref={textRef}
                                            className={[classes.secFac1Hdr, 'animate-charcter'].join(" ")}>{t("cliclSec")}</div>
                                    </div>
                                    <Box
                                        sx={{
                                            paddingRight: {
                                                xs: "0",
                                                sm: "0",
                                            },
                                        }}
                                        className="row justify-content-center w-100 ml-0 mr-0"
                                    >
                                        <Grid
                                            item
                                            lg={7}
                                            style={{
                                                textAlign: "right",
                                                margin: "auto",
                                                padding: "0",
                                            }}
                                        >
                                            <div className="row justify-content-center w-100 ml-0 mr-0">
                                                <Box
                                                    sx={{
                                                        marginTop: {
                                                            xs: "50px",
                                                            sm: "50px",
                                                            md: "0",
                                                            lg: "0",
                                                        },
                                                    }}
                                                    style={{ padding: "0" }}
                                                >
                                                    <div>
                                                        <LazyLoadImage
                                                            className="main-img"
                                                            width="100%"
                                                            height="100%"
                                                            alt="image Alt and Title"
                                                            src={
                                                                process.env.PUBLIC_URL +
                                                                "/images/mainFacilities.jpg"
                                                            }
                                                            style={{ margin: "auto" }}
                                                        />
                                                    </div>
                                                </Box>
                                            </div>
                                        </Grid>
                                        <Grid
                                            item
                                            lg={5}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            style={{ margin: "auto", transform: "translateX(25%)" }}
                                        >
                                            <div className="row justify-content-center w-100 ml-0 mr-0">
                                                <div className={classes.secFac2Hdr}>
                                                    <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                                                        {t("facSec")}
                                                    </ScrollAnimation>
                                                </div>
                                            </div>
                                            <div className="row justify-content-center w-100 ml-0 mr-0">
                                                <div style={{ width: "80%" }}>
                                                    <div className="row w-100 ml-0 mr-0 mt-4">
                                                        <div className={classes.facilitySecTxt}>
                                                            {t("buyExpln")}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={classes.btnFixDiv}>
                                                <Grid
                                                    item
                                                    lg={2}
                                                    style={{
                                                        marginRight: "60%",
                                                    }}
                                                    className={classes.btnFix}
                                                >
                                                    <GeneralButton
                                                        clicked={() => {
                                                            history.push("fac-form");
                                                        }}
                                                        text={<>{t("facility")}</>}
                                                    />
                                                </Grid>
                                            </div>
                                        </Grid>
                                    </Box>
                                </Box>
                            </div>
                        </Box>
                    </ScrollAnimation>
                </Grid>
            </Box>
        </section>
    )
}

export default FacilitySection;